import React from "react";
import themeLarge from "../ThemeLarge";

class KeywordView extends React.Component {
  constructor(props) {
    super(props);
    this.keyword = props.keyword;
  }

  render() {
    return (
      <div
        style={{
          backgroundColor: themeLarge.colors.bg,
          fontSize: themeLarge.fontSize.small,
          borderRadius: "15px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: themeLarge.colors.hover,
          paddingLeft: "15px",
          paddingRight: "15px",
          paddingTop: "5px",
          paddingBottom: "5px",
          width: "fit-content",
          margin : "5px",
          boxShadow: themeLarge.shadows.little,
        }}
      >
        {this.keyword}
      </div>
    );
  }
}

export default KeywordView;
